import React from 'react';
import { localDateTimeDisplay } from '../../../../../utils/date-time-utils';
import { AgisticsTooltip } from '../../../../shared/agistics-tooltip';

interface LoadStopTimeProps {
    time: string | null;
    withToolip?: boolean;
}

export const LoadStopTime: React.FC<LoadStopTimeProps> = (props) => {
    const { time, withToolip } = props;

    if (!time) {
        return null;
    }

    const loadStopTime = localDateTimeDisplay(time);

    if (withToolip) {
        return (
            <AgisticsTooltip
                tooltip={loadStopTime}
            >
                {loadStopTime}
            </AgisticsTooltip>
        );
    }

    return loadStopTime;
};
